import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

// Import views
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';
import EntityList from '@/views/EntityList.vue';
import EntityDetail from '@/views/EntityDetail.vue';
import NotFound from '@/views/NotFound.vue';
import Profile from '@/views/Profile.vue';
import SearchResults from '@/views/SearchResults.vue';
import Systems from '@/views/Systems.vue';
import VerifyEmail from '@/views/VerifyEmail.vue';
import Analytics from '@/views/Analytics.vue';

// Create placeholder views for new routes
//const QueryTool = { template: '<div class="p-8"><h1 class="text-2xl font-bold mb-4">Query Tool</h1><p>This is the Query Tool page.</p></div>' };
//const Systems = { template: '<div class="p-8"><h1 class="text-2xl font-bold mb-4">My Systems</h1><p>This is the My Systems page.</p></div>' };
const Reports = { template: '<div class="p-8"><h1 class="text-2xl font-bold mb-4">Reports</h1><p>This is the Reports page.</p></div>' };

// Route configuration
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: VerifyEmail
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'SearchResults',
    component: SearchResults,
    meta: { requiresAuth: true }
  },
  {
    path: '/systems',
    name: 'Systems',
    component: Systems,
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: { requiresAuth: true }
  },
  {
    path: '/:entityType',
    name: 'EntityList',
    component: EntityList,
    meta: { requiresAuth: true }
  },
  {
    path: '/:entityType/:id',
    name: 'EntityDetail',
    component: EntityDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navigation guard for protected routes
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const userIsAuthenticated = store.getters.isAuthenticated;
  
  if (requiresAuth && !userIsAuthenticated) {
    console.log('Authentication required, redirecting to login');
    next('/login');
  } else {
    next();
  }
});

export default router;
